// IMPORT VENDOR
import $ from "jquery";
window.$ = window.jQuery = $;

import { Foundation } from "foundation-sites/js/foundation.core";
import { Reveal } from "foundation-sites/js/foundation.reveal";
Foundation.addToJquery($);
Foundation.plugin(Reveal, "Reveal");
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
Foundation.plugin(MediaQuery, 'MediaQuery');

// IMPORT DES COMPONENTS
//import { utils } from "./components/_utils";

// IMPORT DES PAGES
import { bdc } from "./pages/bon-de-commande";

// ----------------------------------- DOCUMENT READY -----------------------------------
// --------------------------------------------------------------------------------------
jQuery(function () {
  let bodyClassList = document.getElementsByTagName("body")[0].classList;
  switch (true) {
    case bodyClassList.contains("page-template-page-bon-de-commande"):
      bdc.readyFn();
      break;
  }

});

// ----------------------------------- WINDOW LOAD --------------------------------------
// --------------------------------------------------------------------------------------
$(window).on("load", function () {

  $(document).foundation();

  scrollFunction();
  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      document.body.scrollTop > 80 ||
      document.documentElement.scrollTop > 80
    ) {
      $("header, a#desktop-nav-toggle").addClass("smaller");
    } else {
      $("header, a#desktop-nav-toggle").removeClass("smaller");
    }
  }

  $(document).on("click", "#to-top", function () {
    globalThis.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  });

});

// ----------------------------------- WINDOW RESIZE ------------------------------------
// --------------------------------------------------------------------------------------
$(window).on("resize", function () { });
